import { Button } from "../ui";
import { navigateExternal, postLiveChatEvent } from "../lib/postmessage";
import { useLabel } from "../lib/labels";

interface LiveChatCtaData {
  locale: string;
  /** 버튼 노출 플래그 — 서버(harness)가 path×업무시간×로그인으로 판정해 전달. */
  showLiveChat?: boolean;
  showEmail?: boolean;
  showGoToBasket?: boolean;
  /** Email 문의 페이지 full URL. 서버(``build_nav_url``)가 채운다 (CTA_NAVIGATE_GAP §0). */
  emailContactUrl?: string;
  /** Go to Basket(NCMS /cart) full URL. 서버가 채운다 (구매하기 §3-1). */
  goToBasketUrl?: string;
}

interface Props {
  data: LiveChatCtaData;
  sessionToken: string;
}

export default function LiveChatCtaCard({ data, sessionToken }: Props) {
  const goToBasketLabel = useLabel("goToBasket", "Go to Basket");
  // AISASSIT-162: Figma/ai-lists 구매하기 화면 버튼 라벨 — "Connect to Live Chat".
  const liveChatLabel = useLabel("liveChat", "Connect to Live Chat");
  const emailLabel = useLabel("email", "Email");

  const handleLiveChat = () => {
    postLiveChatEvent();
  };

  const handleEmail = () => {
    if (!data.emailContactUrl) {
      console.warn("[LiveChatCtaCard] data.emailContactUrl 누락 — 서버가 build_nav_url 로 채워야 함");
      return;
    }
    navigateExternal(data.emailContactUrl, { target: "_top" }, { sessionId: sessionToken });
  };

  const handleGoToBasket = () => {
    if (!data.goToBasketUrl) {
      console.warn("[LiveChatCtaCard] data.goToBasketUrl 누락 — 서버가 build_nav_url 로 채워야 함");
      return;
    }
    navigateExternal(data.goToBasketUrl, { target: "_top" }, { sessionId: sessionToken });
  };

  // 안내 문구(7-1)는 위젯 위 text 슬롯(assistant_message)으로 발행된다 — 여기 하드코딩 금지.
  // 본 위젯은 서버 플래그대로 버튼만 렌더한다(LIVE_CHAT.md §1).
  // 버튼 순서: 보조 액션(Go to Basket / Email) → 주 액션(Connect to Live Chat) 을 항상 맨 오른쪽.
  // AISASSIT-162(reopen): Live Chat 은 primary(빨강)·최우측 고정. 시나리오별로 좌측 보조버튼만 달라진다.
  //   · [9.구매하기]        Go to Basket(흰) ← 좌 / Connect to Live Chat(빨강) → 우
  //   · [13.추가 상담채널]   Email(흰)        ← 좌 / Connect to Live Chat(빨강) → 우
  // Figma/ai-lists = .ai-gp1-btn-wrap (콘텐츠 폭·좌측정렬·8px gap). 기존 .ac-confirm__actions(50/50)와 달라 정합.
  return (
    <div className="ai-gp1--section">
      <div className="ai-gp1-btn-wrap">
        {data.showGoToBasket && (
          <Button
            variant="secondary"
            size="sm"
            onClick={handleGoToBasket}
          >
            {goToBasketLabel}
          </Button>
        )}
        {data.showEmail && (
          <Button
            variant="secondary"
            size="sm"
            onClick={handleEmail}
          >
            {emailLabel}
          </Button>
        )}
        {data.showLiveChat && (
          <Button
            variant="primary"
            size="sm"
            onClick={handleLiveChat}
          >
            {liveChatLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
